<div
  class="fc-outlined-input"
  [class.disabled]="control.disabled"
  [class.invalid]="control.touched && control.invalid"
  [class.with-hint]="!!maxLength"
>
  <div class="fc-outlined-input__prefix" (click)="input.focus()" *ngIf="prefixIcon">
    <mat-icon>{{ prefixIcon }}</mat-icon>
  </div>
  <div class="fc-outlined-input__infix" [class.float-label]="control.value">
    <label class="fc-outlined-input__infix-label"> {{ label }}<span *ngIf="required">*</span> </label>
    <input
      #input
      [type]="inputType"
      autocomplete="off"
      class="fc-outlined-input__infix-input"
      [formControl]="control"
      [maxlength]="maxLength"
      (keyup)="$event.key === 'Enter' && control.valid && next.emit()"
    />
    <small class="fc-outlined-input__infix-hint" *ngIf="maxLength">
      ({{ (control.value?.length || 0) + '/' + maxLength }})
    </small>
    <small
      *ngIf="control.touched && control.invalid"
      class="fc-outlined-input__infix-error"
      [class.fc-outlined-input__infix-error--without-overflow]="!!hideErrorTextEllipses"
    >
      <ng-content></ng-content>
    </small>
  </div>

  <div class="fc-outlined-input__suffix" *ngIf="isPassword">
    <button type="button" class="fc-outlined-input__suffix-button" (click)="changePasswordInputType()" mat-icon-button>
      <mat-icon>{{ inputType === 'text' ? 'visibility' : 'visibility_off' }}</mat-icon>
    </button>
  </div>
</div>
